import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Modal, Row, Col, Button, Image } from "react-bootstrap";

const customStyles = {
  message: {
    fontSize: "14px",
  },
  premiumText: {
    fontWeight: "700",
    fontSize: "14px",
    textAlign: "center",
    color: "#FFBB00",
    position: "absolute",
    bottom: "25%",
  },
  premiumIcon: {
    color: "#FFBB00",
    marginRight: "5px",
  },
  serviceImage: {
    width: "100px",
  },
};

export default function PurchaseModuleModal(props) {
  // Destructure props
  const {
    size = "md",
    name = "sce",
    originView = "Campus Móvil",
    showModal,
    closeModal,
  } = props;

  // Hooks
  const [t] = useTranslation(["global"]);
  const [service, setService] = useState({
    title: "",
    text: "",
    imgSrc: "",
  });

  // Services availables to purchase
  const services = {
    sce: {
      title: t("global:purchaseModuleModal.sce"),
      text: t("global:purchaseModuleModal.message", {
        originView,
        serviceName: t("global:purchaseModuleModal.sce"),
      }),
      imgSrc: "./img/dashboard-icons/default/students.svg",
    },
    reviews: {
      title: t("global:purchaseModuleModal.reviews"),
      text: t("global:purchaseModuleModal.message", {
        originView,
        serviceName: t("global:purchaseModuleModal.reviews"),
      }),
      imgSrc: "./img/dashboard-icons/default/reviews.svg",
    },
    app: {
      title: t("global:purchaseModuleModal.app"),
      text: t("global:purchaseModuleModal.message", {
        originView,
        serviceName: t("global:purchaseModuleModal.app"),
      }),
      imgSrc: "./img/dashboard-icons/default/app.svg",
    },
    payments: {
      title: t("global:purchaseModuleModal.payments"),
      text: t("global:purchaseModuleModal.message", {
        originView,
        serviceName: t("global:purchaseModuleModal.payments"),
      }),
      imgSrc: "./img/dashboard-icons/default/students.svg",
    },
  };

  /**
   * Initial Loading
   */
  useEffect(() => {
    setService(services[name]);
  }, [name]);

  /**
   * Description: Function to redirect to the demo scheduling page
   */
  const scheduleDemo = useCallback(() => {
    window.open("https://www.campusmovil.com.mx/contacto/", "_blank");
  }, []);

  return (
    <Modal
      id="PurchaseModuleModal"
      show={showModal}
      size={size}
      aria-labelledby="contained-modal-title-md"
    >
      <Modal.Header className="modal-header">
        <Modal.Title className="modal-title text-center">
          {t("purchaseModuleModal.title") + " " + service.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Row>
          <Col md={12} style={customStyles.message}>
            {service.text}
          </Col>
        </Row>
        <Row className="mt-3 text-center">
          <Col md={12}>
            <Image
              className="mt-2"
              fluid
              rounded
              src={service.imgSrc}
              style={customStyles.serviceImage}
            />
            <span style={customStyles.premiumText}>
              <i className="fas fa-crown" style={customStyles.premiumIcon} />
              Premium
            </span>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md={12} className="text-center">
            <Button onClick={scheduleDemo}>{t("global:scheduleDemo")}</Button>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={closeModal}>
          {t("global:buttons.close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

PurchaseModuleModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  originView: PropTypes.string.isRequired,
  size: PropTypes.string,
};
